var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12, _polygon2, _path13, _path14, _circle, _path15, _path16, _polygon3, _path17, _path18, _rect, _path19, _circle2, _rect2, _rect3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYesNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 789.38189,
    height: 609.37605,
    viewBox: "0 0 789.38189 609.37605",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M981.30863,673.98326c-3.3177-26.67814-19.85136-52.96384-45.29423-61.64564a123.86328,123.86328,0,0,1-.00614,85.04048c-3.90959,10.57529-9.35913,21.9305-5.68164,32.58879,2.28808,6.6319,7.88558,11.70587,14.14246,14.8785,6.25726,3.17262,13.20151,4.68476,20.05886,6.16664l1.34956,1.11616C976.76344,727.54719,984.62633,700.66139,981.30863,673.98326Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M935.76192,612.84207a105.86968,105.86968,0,0,1,26.319,59.58345,45.59092,45.59092,0,0,1-.51859,14.27515,26.14853,26.14853,0,0,1-6.50348,12.12824c-2.93125,3.22058-6.30256,6.17542-8.3999,10.05246a16.01082,16.01082,0,0,0-.78221,13.07063c1.85173,5.31109,5.5014,9.64009,9.21758,13.74945,4.12612,4.56267,8.48415,9.23648,10.23806,15.28536.21251.73291,1.33731.36031,1.12512-.37149C963.406,740.0913,953.19,734.11345,948.318,724.6346c-2.27337-4.423-3.22759-9.55792-1.09634-14.22686,1.86369-4.08278,5.33761-7.13282,8.33375-10.36807a27.9025,27.9025,0,0,0,6.80084-11.62188,42.14785,42.14785,0,0,0,1.06552-14.20255,102.71271,102.71271,0,0,0-7.50152-31.21348,107.74726,107.74726,0,0,0-19.37431-31.04834c-.50661-.56729-1.2873.32506-.784.88865Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M961.762,665.25515a15.88384,15.88384,0,0,0,12.09074-16.6389c-.06037-.76-1.24414-.70185-1.18369.05912A14.70808,14.70808,0,0,1,961.39055,664.13c-.74175.17635-.366,1.30046.37149,1.12512Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M956.76024,697.3917a30.61483,30.61483,0,0,1-13.67135-17.63188c-.21509-.73213-1.34-.35975-1.12511.37149A31.844,31.844,0,0,0,956.22734,698.45c.657.38973,1.18635-.67065.5329-1.05826Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M950.18063,632.74567a8.991,8.991,0,0,1-8.52045-.43252c-.65175-.39787-1.18041.663-.53289,1.05826a10.07516,10.07516,0,0,0,9.42483.49938.61233.61233,0,0,0,.37681-.74831.59543.59543,0,0,0-.7483-.37681Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M858.461,659.988c.3999.26.7998.52,1.20019.79A118.40547,118.40547,0,0,1,874.80079,672.598c.37012.33.74024.67,1.1001,1.01a124.82722,124.82722,0,0,1,27.10986,37.11,121.22215,121.22215,0,0,1,6.64014,17.18c2.4502,8.13,4.46,17.14,9.31006,23.79a20.79633,20.79633,0,0,0,1.62012,2h43.83007c.09961-.05.19971-.09.29981-.14l1.75.08c-.07031-.31-.1499-.63-.22022-.94-.04-.18-.08984-.36-.12988-.54-.02978-.12-.06006-.24-.08008-.35-.00976-.04-.02-.08-.02978-.11-.02-.11-.0503-.21-.07031-.31q-.65993-2.685-1.35987-5.37c0-.01,0-.01-.00976-.02-3.59034-13.63-8.3501-27.08-15-39.38-.2002-.37-.39991-.75-.62012-1.12a115.674,115.674,0,0,0-10.39014-15.76,102.26,102.26,0,0,0-6.81006-7.79,85.03677,85.03677,0,0,0-21.27978-15.94c-15.72022-8.3-33.91992-11.48-50.72022-6.41C859.31105,659.718,858.89064,659.848,858.461,659.988Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#f0f0f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M858.55949,660.54431a105.86972,105.86972,0,0,1,56.88764,31.72816,45.59157,45.59157,0,0,1,8.18056,11.71014,26.1486,26.1486,0,0,1,2.10937,13.59926c-.40143,4.33627-1.31421,8.72531-.65457,13.08366a16.01082,16.01082,0,0,0,7.24486,10.9071c4.67616,3.12574,10.19656,4.38485,15.63785,5.42855,6.04151,1.15883,12.33511,2.26677,17.37736,6.04049.61093.45724,1.28469-.51747.67468-.974-8.77265-6.56562-20.52867-5.18784-30.12561-9.82289-4.47812-2.16279-8.33158-5.68823-9.44092-10.69927-.97006-4.38194-.03267-8.90877.41174-13.29582a27.90246,27.90246,0,0,0-1.56708-13.374,42.148,42.148,0,0,0-7.70016-11.98146A102.71248,102.71248,0,0,0,892.813,672.48844a107.74717,107.74717,0,0,0-34.16254-13.12569c-.746-.14794-.83214,1.03459-.091,1.18156Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M910.87542,686.73935a15.88384,15.88384,0,0,0-.364-20.56469c-.50575-.57043-1.41593.18868-.90952.75987a14.70808,14.70808,0,0,1,.2995,19.13014c-.48607.58739.49073,1.25871.974.67468Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M926.23018,715.41a30.61484,30.61484,0,0,1-21.53141-5.847c-.61253-.45506-1.28648.51951-.67468.974a31.844,31.844,0,0,0,22.41775,6.03876c.75924-.08439.54346-1.24974-.21166-1.1658Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M882.05536,667.75516a8.991,8.991,0,0,1-7.06351,4.78455c-.75993.07473-.54333,1.24.21166,1.16581a10.07517,10.07517,0,0,0,7.82586-5.27568.61233.61233,0,0,0-.14966-.82434.59543.59543,0,0,0-.82435.14966Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M644.013,177.9134a11.55371,11.55371,0,0,0,3.48192,17.37071l-6.75629,40.49833,19.50168-8.65478,3.42607-37.131A11.61633,11.61633,0,0,0,644.013,177.9134Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#9e616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "614.147 592.883 598.201 592.882 590.615 531.376 614.15 531.377 614.147 592.883",
    fill: "#9e616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M823.52267,753.65224l-51.41667-.00191V753a20.01386,20.01386,0,0,1,20.0128-20.01248h.00127l31.40355.00127Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "507.147 592.883 491.201 592.882 483.615 531.376 507.15 531.377 507.147 592.883",
    fill: "#9e616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M716.52267,753.65224l-51.41667-.00191V753a20.01386,20.01386,0,0,1,20.0128-20.01248h.00127l31.40355.00127Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M705.80906,451.188l-5.96041,7.83915s-.53959,3.66085-9.58036,33.48559L685.30906,716.688h30l40.10008-179.36611,41.61813,182.96453,26.006,1.53431-1.223-207.95912s3.285-42.783-8.35809-50.72832S705.80906,451.188,705.80906,451.188Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540.73169,
    cy: 86.01289,
    r: 31.4805,
    fill: "#9e616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M777.71091,236.25346l-.52-1.03956c-.80371-1.60791-7.46045-14.97509-8.2959-18.41211l-8.37744.98536-21.81543.00341,3.03125-4.54687-8.01416,1.04541a18.39333,18.39333,0,0,0-8.16675,3.07812,12.51308,12.51308,0,0,0-3.70434,3.81934c-2.8628,4.90234-7.23657,12.9209-7.28052,13.00147l-.41821.76709-3.63452-6.11377c-.04761-.23731-4.552-23.731,10.52246-31.69873.77758-1.57911,7.40283-14,23.06054-13.16163a9.927,9.927,0,0,1,6.74927-3.355c3.57593-.18652,7.28784,1.6919,11.01538,5.60645,4.95166,5.19922,11.7334,12.31933,15.835,20.2251l1.13159,1.61425a12.723,12.723,0,0,1,2.26368,7.89942,26.37238,26.37238,0,0,1-.89869,13.45264Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M770.02681,268.7288l17.4198,9.62779,34.21783,9.581L811.45079,377.4833l1.85827,88.20473s-57.92082,39.67831-113.46041-6.66085V348.003l3.28564-60.06537s13.29045-3.77562,19.98261,2.73739l12.69216-16.487Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e4e4e4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.5 150.876 497.825 142.626 455.531 137.835 459.5 72.876 436.441 56.426 419.5 147.876 497.758 202.691 505.5 150.876",
    fill: "#e4e4e4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M796.542,494.83593a11.55369,11.55369,0,0,1,11.22028-13.71024l13.02142-38.93847,13.167,16.78843-14.384,34.40278a11.61634,11.61634,0,0,1-23.02468,1.4575Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#9e616a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M808.80906,298.188l12.85538-10.25041s13.14462,7.25041,17.14462,20.25041,11,87,11,87l-19,95-21.248-14.73622,10.248-75.26378-18-55Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e4e4e4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 118.14267,
    width: 324.20229,
    height: 78.78223,
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M331.95817,215.58747H639.14761V153.81872H331.95817Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.15875,
    cy: 39.39113,
    r: 23.53234,
    fill: "#3081d0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 241.43181,
    y: 30.1828,
    width: 157.42938,
    height: 5.11573,
    fill: "#3081d0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 241.43181,
    y: 43.4837,
    width: 157.42938,
    height: 5.11573,
    fill: "#3081d0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "b9910470-ced5-4346-b4bb-f41b58844e24-1355",
    "data-name": "Rectangle 1",
    d: "M205.30906,265.05374l274.314,20.00879v72.02436l-274.314-5.09394Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "bc7e8449-b99b-4317-a70a-91d17db61b29-1356",
    "data-name": "Path 1",
    d: "M213.95028,342.81775l259.6838,6.35125V292.437L213.95028,275.0205Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "a430bd6b-b2b0-4af3-a079-7f5fd15b0624-1357",
    "data-name": "Ellipse 1",
    d: "M270.9457,286.6233a20.6486,20.6486,0,0,1,8.55537,2.477,23.8163,23.8163,0,0,1,6.91581,5.70319,26.93424,26.93424,0,0,1,4.627,8.072,28.22787,28.22787,0,0,1,1.69014,9.64449,26.93413,26.93413,0,0,1-1.69014,9.48924,23.921,23.921,0,0,1-4.627,7.65326,20.88621,20.88621,0,0,1-6.91581,5.07041,19.40656,19.40656,0,0,1-8.55537,1.69367,20.48626,20.48626,0,0,1-8.65181-2.22294,23.603,23.603,0,0,1-7.1381-5.61145,26.82446,26.82446,0,0,1-4.8493-8.19194,28.21724,28.21724,0,0,1-1.78541-9.89971,26.89277,26.89277,0,0,1,1.78541-9.74211,23.77583,23.77583,0,0,1,4.85047-7.745,20.73928,20.73928,0,0,1,7.1381-4.95751A19.396,19.396,0,0,1,270.9457,286.6233Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "af019097-0949-417a-9d8d-f710312ce60c-1358",
    "data-name": "Rectangle 2",
    d: "M322.0368,304.44443l126.38871,6.58649v4.787L322.0368,309.67716Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "f94f3612-92b8-42d6-ae14-2a9ea684588e-1359",
    "data-name": "Rectangle 3",
    d: "M322.0368,318.0514,448.42551,323.477v4.787L322.0368,323.28412Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "bb553635-e14d-4b1e-b72c-855829e3ad86-1360",
    "data-name": "Rectangle 4",
    d: "M205.30906,411.36656l274.314-5.09277v72.02436l-274.314,20.00879Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "e92d7e39-9dcb-4c0c-b0b9-55aac094bc0c-1361",
    "data-name": "Path 2",
    d: "M213.95028,488.339l259.6838-17.41654V414.19639l-259.6838,6.35125Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "f8649409-803b-4d56-993a-4da6ceb3c345-1362",
    "data-name": "Ellipse 2",
    d: "M248.5399,451.71229a28.18078,28.18078,0,0,1,2.18412-9.81974,26.49781,26.49781,0,0,1,5.16686-7.94142,23.201,23.201,0,0,1,7.3404-5.24566,20.24279,20.24279,0,0,1,8.7118-1.7807,19.443,19.443,0,0,1,8.45775,2.13,21.1825,21.1825,0,0,1,6.69,5.42209,24.31932,24.31932,0,0,1,4.30827,7.89084,27.20924,27.20924,0,0,1,1.30906,9.581,28.19721,28.19721,0,0,1-2.06768,9.568,26.62605,26.62605,0,0,1-4.93986,7.852,23.41734,23.41734,0,0,1-7.12752,5.35974,20.38864,20.38864,0,0,1-8.63535,2.043,19.41486,19.41486,0,0,1-8.57419-1.88185,21.02727,21.02727,0,0,1-6.9158-5.32917,24.18434,24.18434,0,0,1-4.52233-8.00493A27.17635,27.17635,0,0,1,248.5399,451.71229Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "f70c4d59-0dd2-4f0b-ba41-17bf719deab5-1363",
    "data-name": "Rectangle 5",
    d: "M322.0368,440.07655l126.38871-4.97985v4.787L322.0368,445.30928Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "ba176e8f-fd02-45f1-a5f1-dcef4bb8b7ed-1364",
    "data-name": "Rectangle 6",
    d: "M322.0368,453.68234l126.38871-6.13954v4.787L322.0368,458.91625Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M993.69094,754.688h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-205.30906 -145.31197)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesNo);
export default __webpack_public_path__ + "static/media/yes_no.f66769828a119096223241d8acad1d35.svg";
export { ForwardRef as ReactComponent };